import gql from "graphql-tag";

export default gql`
  subscription subscribeToProcessFinished($concreteShipmentId: Int!) {
    subscribeToProcessFinished(
      concreteShipmentId: $concreteShipmentId,
    )
  }
`;
